var React = require('react');

function PhoneIconDarkInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","rx":"10","fill":"current","key":0}),React.createElement("path",{"d":"M9.07941 10.9203C10.2652 12.1093 11.6389 13.2443 12.1833 12.7003C12.9616 11.9203 13.4415 11.2438 15.1582 12.6228C16.8749 14.0018 15.5561 14.9218 14.8023 15.6758C13.9324 16.5458 10.6901 15.7213 7.48373 12.5158C4.27736 9.31036 3.45453 6.0669 4.32436 5.19591C5.0802 4.44342 5.99752 3.12643 7.37625 4.84041C8.75497 6.55439 8.07761 7.03539 7.29976 7.81338C6.75587 8.36037 7.89064 9.73385 9.07941 10.9203Z","fill":"#141414","key":1})]);
}

PhoneIconDarkInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = PhoneIconDarkInline;

PhoneIconDarkInline.default = PhoneIconDarkInline;
